<template>
    <NuxtLink
        :to="link"
        class="!h-auto">
        <div
            class="group h-full overflow-hidden rounded-12 bg-[#FFFFFF0D] p-3 transition-colors duration-300 md:hover:bg-white/15 md:hover:text-ash-200">
            <div class="aspect-video w-full overflow-hidden rounded-12">
                <picture
                    class="aspect-video w-full object-cover transition-all duration-500 md:group-hover:scale-110">
                    <source
                        v-if="image?.webp_url"
                        type="image/webp"
                        :srcset="getMediaLink(image.webp_url, 600) || ''" />

                    <source
                        v-else-if="!image?.url && !image?.webp_url"
                        type="image/webp"
                        srcset="
                            /assets/images/ui/placeholder/webp/cromi.webp
                        " />

                    <img
                        loading="lazy"
                        :alt="image?.alt || 'нет изображения'"
                        :src="
                            getMediaLink(image?.url || '', 600) ||
                            '/assets/images/ui/placeholder/jpg-png/cromi.png'
                        "
                        class="aspect-video w-full object-cover transition-all duration-500 md:group-hover:scale-110" />
                </picture>
            </div>
            <time
                v-if="!hideDate && item.published_at"
                v-html="date"
                :datetime="item.published_at"
                class="mt-5 block text-16/148 font-medium text-accent-100" />
            <div class="mt-2 md:mt-3">
                <h3
                    v-html="item.name"
                    class="text-20/120 font-semibold text-ash-200 lg:text-24/133" />
                <div
                    v-html="item.preview_description"
                    class="tinyeditor mt-2 line-clamp-4 text-16/150 font-medium text-accent-100 max-sm:hidden md:mt-5" />
            </div>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
import type { Image } from '~/types/global.types'

import { formatPublicationDate } from '~/utils/publication-date'

import type { IArticleItem, INewsItem } from './news-section.types'

const props = defineProps({
    item: {
        type: Object as PropType<INewsItem | IArticleItem>,
        required: true,
    },
    cardType: {
        type: String as PropType<'news' | 'article'>,
        default: 'news',
    },
    hideDate: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const link = computed<string>(() => {
    let domain = ``
    switch (props.item.site) {
        case 'radioguide':
            domain = 'radioguide.rent'
            break
        case 'ru':
            domain = 'cromi.ru'
            break
        default:
            domain = 'cromi.rent'
    }

    return `https://www.${domain}/${props.cardType === 'news' ? 'news' : 'pro'}/${props.item.slug}/`
})

const image = computed<Image | null>(() => {
    if (Array.isArray(props.item.image)) {
        return props.item.image[0] || null
    } else {
        return props.item.image
    }
})

const date = computed<string>(() => {
    if (!props.item.published_at) return ''

    return formatPublicationDate(props.item.published_at)
})
</script>
